import React, { useEffect, useState } from "react";
import Testimonials from "../../components/Testimonial";
import { AllPrograms, ProgramDetailResponse } from "../../interfaces/Program";
import { programsDetailsConfig } from "../../SliderProperties/ProgramConfig";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  fetchDataProgramDetails,
  fetchProgramsFilter,
} from "../../store/ProgramSlice";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Sessions from "../../components/Sessions";
import { useNavigate, useParams } from "react-router-dom";
import ReadMoreComponent from "../../components/ReadMore";
import ProgramMinimalCard from "../../components/ProgramMinimalCard";
import { ISession } from "../../interfaces/Session";
import { createPaymentFree } from "../../store/paymentSlice";
const limit = 10;

export default function Program() {
  const dispatch = useDispatch<any>();
  const { programSlug } = useParams<{ programSlug: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (programSlug) {
      // Dispatch the action to fetch program details
      dispatch(fetchDataProgramDetails(programSlug));
    }
  }, [dispatch, programSlug]);

  const programData = useSelector((state: RootState) => {
    return state.programs.data1;
  });
  const formattedStartDate =
    programData?.startDate &&
    new Date(programData.startDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  const sessionData = programData?.sessions;
  const sessions: ISession[] | undefined = sessionData;
  const isBooked = programData?.isBooked;

  const programsAll = useSelector((state: RootState) => {
    return state.programs.data || ([] as AllPrograms[]);
  });

  useEffect(() => {
    if (programSlug) {
      // Dispatch the action to fetch program details
      dispatch(fetchProgramsFilter({ programSlug, limit }));
    }
  }, [dispatch, programSlug]);



  const handleClick = () => {
    navigate('/checkout', { state: { programid: programData?.id, title: programData?.title, icon: programData?.icon, cost: programData?.cost, date: formattedStartDate } });
  };


  const handleFreeClick = () => {
    dispatch(createPaymentFree({ programId: programData?.id })).then(() => {
      //closePopup();
      navigate('/thankyou');
    });

  };

  return (
    <>
      <div className="relative">
        <div
          className="bg-cover bg-center text-center text-white p-8 "
          style={{
            backgroundImage: `url("./images/innerb.jpg")`,
          }}
        >
          <div className="text-center pt-40 pb-28">
            <h1 className="text-2xl md:text-4xl font-bold">Program Details</h1>
          </div>
        </div>
      </div>

      <div className="container flex flex-col md:flex-row mx-auto my-10 items-center justify-center ">
        <div className=" md:basis-1/2">
          <h2 className="font-semibold text-2xl md:text-4xl capitalize text-[#020220] tracking-wide mt-2 mb-2 ml-4 md:hidden">
            {programData?.title}
          </h2>
          <img
            src={programData?.icon}
            alt="about"
            className="p-4"
          />
        </div>

        <div className="basis-full md:basis-1/2 p-6">
          <h2 className="font-semibold text-2xl md:text-4xl capitalize text-[#020220] tracking-wide mt-2 mb-8 hidden md:block">
            {programData?.title}
          </h2>
          <p className="mb-4 text-[#546E7A]">
            <ReadMoreComponent
              text={programData?.description ?? ""}
              maxLength={300}
            />
          </p>
          <div className="flex  gap-6">
            <div className="rounded-lg basis-6/12 shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] p-4 mb-6">
              <p className="text-[#607D8B] mb-2">Date</p>
              <p className="text-xl">{formattedStartDate}</p>
            </div>
            <div className="rounded-lg basis-6/12 shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] p-4 mb-6">
              <p className="text-[#607D8B] mb-2">Total Slots</p>
              <p className="text-xl">{(programData?.maxParticipants && programData?.maxParticipants < 9999) ? (
                programData?.bookedSlots ? `${programData?.bookedSlots} / ${programData?.maxParticipants}` : `0 / ${programData?.maxParticipants}`
              ) : "No limits"}</p>

            </div>
          </div>

          <div className="my-8">
            <p className="text-4xl font-bold text-[#037897]">
              $ {programData?.cost}
            </p>
          </div>
          {
            typeof programData?.cost === 'number' && programData?.cost === 0 ? (
              !isBooked ? (
                <button
                  className="uppercase bg-[#037897] text-white py-4 leading-3 font-bold rounded-md px-8"
                  onClick={() => {
                    handleFreeClick();
                  }}
                >
                  Réserver Gratuitement
                </button>
              ) : (
                <p className="text-[#e11d48]">You have already booked this program.</p>
              )
            ) : (
              programData?.bookedSlots !== undefined &&
                programData?.maxParticipants !== undefined ? (
                (programData?.bookedSlots < programData?.maxParticipants || programData?.maxParticipants === 9999) ? (
                  !isBooked ? (
                    <button
                      className="uppercase bg-[#037897] text-white py-4 leading-3 font-bold rounded-md px-8"
                      onClick={() => {
                        handleClick();
                      }}
                    >
                      Réserver Maintenant
                    </button>
                  ) : (
                    <p className="text-[#e11d48]">You have already booked this program.</p>
                  )
                ) : (
                  <p className="text-[#e11d48]">This Program is Full.</p>
                )
              ) : null
            )
          }

        </div>
      </div>
      {/* sessions section */}
      {sessions && sessions.length > 0 && <Sessions sessionData={sessions} />}

      <div
        style={{ backgroundImage: `url("./images/bg-d.jpg")` }}
        className="bg-cover bg-no-repeat relative p-2 pb-8"
      >
        <div className="container  md:mx-auto my-10 items-center justify-center ">
          <h4 className="text-center text-lg text-[#fff] capitalize mb-4 pt-10">
            Latest Programs
          </h4>
          <h2 className="text-center font-semibold text-2xl md:text-4xl capitalize text-white tracking-wide mb-10">
            You may also like other programs
          </h2>
          {programsAll.length > 0 && (
            <div className="mb-16">
              <Slider {...programsDetailsConfig}>
                {programsAll.map((programs: AllPrograms) => (
                  <ProgramMinimalCard key={programs.id} program={programs} />
                ))}
              </Slider>
            </div>
          )}
        </div>
        <div className=" absolute bottom-0 left-0">
          <img
            src="./images/pd-footer.png"
            className="m-auto mt-4"
          ></img>
        </div>
      </div>
      <div className="-m-9"></div>
      <Testimonials />
    </>
  );
}
